import CollegeActionTypes from "./college.types";

export const updateToRoot = (user, role, institution, campuses, personnel, classes) => ({
  type: CollegeActionTypes.UPDATE_TO_ROOT,
  payload: { user, role, institution, campuses, personnel, classes }
})

export const updateUserDetails = (user) => ({
  type: CollegeActionTypes.UPDATE_USER_DETAILS,
  payload: user
})

// update personal details for adding profile photo - lieh
export const updatePersonnelDetails = (user) => ({
  type: CollegeActionTypes.UPDATE_PERSONNEL_DETAILS,
  payload: user
})

export const updateInstDetails = (institution) => ({
  type: CollegeActionTypes.UPDATE_COLLEGE_DETAILS,
  payload: institution
})

export const updateInstLogo = (inst_id,suffix) => ({
  type: CollegeActionTypes.UPDATE_INST_LOGO,
  payload:  {inst_id,suffix} 
})

export const updateInstCanDeliver = (can_deliver) => ({
  type: CollegeActionTypes.UPDATE_INST_CAN_DELIVER,
  payload: can_deliver
})

export const updateInstRoomsPrograms = (rooms_programs) => ({
  type: CollegeActionTypes.UPDATE_INST_ROOMS_PROGRAMS,
  payload: rooms_programs
})

export const updateInstTagline = (tagline) => ({
  type: CollegeActionTypes.UPDATE_INST_TAGLINE,
  payload: tagline
})

export const createCampus = (campus) => ({
  type: CollegeActionTypes.ADD_CAMPUS,
  payload: campus
})

export const addCampusToPersonnel = (campus) => ({
  type: CollegeActionTypes.ADD_CAMPUS_TO_PERSONNEL,
  payload: campus
})

export const updateCampus = (campus) => ({
  type: CollegeActionTypes.EDIT_CAMPUS,
  payload: campus
})

export const deleteCampus = (campus) => ({
  type: CollegeActionTypes.DELETE_CAMPUS,
  payload: campus
})

export const createPersonnel = (personnel) => ({
  type: CollegeActionTypes.CREATE_PERSONNEL,
  payload: personnel
})

export const updatePersonnel = (personnel) => ({
  type: CollegeActionTypes.UPDATE_PERSONNEL,
  payload: personnel
})

export const deletePersonnel = (personnel) => ({
  type: CollegeActionTypes.DELETE_PERSONNEL,
  payload: personnel
})

export const createClass = (classObj) => ({
  type: CollegeActionTypes.ADD_CLASS,
  payload: classObj
})

export const updateClass = (class_id, newData) => ({
  type: CollegeActionTypes.EDIT_CLASS,
  payload: { class_id, newData }
})

export const deleteClass = (classObj) => ({
  type: CollegeActionTypes.DELETE_CLASS,
  payload: classObj
})

export const addRemoveFavouriteTeacher = (teacher_id) => ({
  type: CollegeActionTypes.ADD_REMOVE_FAVOURITE_TEACHER,
  payload: teacher_id
})

export const updateInstWebsite = (url) => ({
  type: CollegeActionTypes.UPDATE_INST_WEBSITE,
  payload: url
})

export const blockUnblockTeacher = (teacher_id, is_blocked) => ({
  type: CollegeActionTypes.BLOCK_UNBLOCK_TEACHER,
  payload: { teacher_id, is_blocked }
})

export const updateCustomerInfo = (user) => ({
  type: CollegeActionTypes.UPDATE_CUSTOMER_INFO,
  payload: user
})

export const updateInstitutionInfo = (inst) => ({
  type: CollegeActionTypes.UPDATE_INSTITUTION_INFO,
  payload: inst
})
